export default {
  title: "Votre prestataire s'occupe de cette étape",
  description: {
    payments: 'Contactez {{partner}} pour configurer les paiements en ligne.',
    go_live: 'Contactez {{partner}} pour mettre votre restaurant en ligne.',
  },
  fallback_partner: 'votre prestataire',
};
